import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEmailTemplate } from "../emailTemplateModal";

export const getAllEmailTemplate = createAsyncThunk(
  "EmailTemplate/FindAllEmailTemplate",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/FindAllEmailTemplate`,
        {
          Subject: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createEmailTemplate = createAsyncThunk(
  "EmailTemplate/InsertEmailTemplate",
  async (EmailTemplateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/InsertEmailTemplate`,
        EmailTemplateData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateEmailTemplate = createAsyncThunk(
  "EmailTemplate/UpdateEmailTemplate",
  async (EmailTemplateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/UpdateEmailTemplate`,
        EmailTemplateData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteEmailTemplate = createAsyncThunk(
  "EmailTemplate/DeleteEmailTemplate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/DeleteEmailTemplate`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getEmailTemplateByID = createAsyncThunk(
  "EmailTemplate/FindByIDEmailTemplate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/FindByIDEmailTemplate`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Subject: result.Subject || "",
        Content: result.Content || "",
        IsActive: result.IsActive ? 1 : 2,
      } as IEmailTemplate;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveEmailTemplate = createAsyncThunk(
  "EmailTemplate/FindAllActiveEmailTemplate",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/EmailTemplate/FindAllActiveEmailTemplate`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveEmailTemplate = createAsyncThunk(
  "EmailTemplate/ActiveInActiveEmailTemplate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmailTemplate/ActiveInActiveEmailTemplate`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive EmailTemplate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
